module.exports = __webpack_public_path__ + "7d088296/img/settings-ico.a214628d.svg";